import React, { Component } from 'react'
import Title from './title'
import { FaCocktail, FaHiking, FaShuttleVan, FaBeer } from 'react-icons/fa'
export default class Services extends Component {
    state = {
        services: [
            {
                icon: <FaCocktail/>,
                title: 'Free Cocktails',
                info:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio, dolores!'
            },
            {
                icon: <FaHiking/>,
                title: 'Splendid Hiking',
                info:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio, dolores!'
            },
            {
                icon: <FaShuttleVan/>,
                title: 'Free Exploration',
                info:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio, dolores!'
            },
            {
                icon: <FaBeer/>,
                title: 'Free Drinks',
                info:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio, dolores!'
            }
        ]
    }
    render() {
        return (
            <section className='services'> 
                <Title title='Our Services'/>
                <div className='services-center'>
                    {
                        this.state.services.map((item,index) => {
                            return <article key={index} className='service'>
                                <span>{item.icon}</span>
                                <h6>{item.title}</h6>
                                <p>{item.info}</p>
                            </article>
                        })
                    }
                </div>
            </section> 
        )
    }
}
